import {SOPostInterphace} from '../../core/interphace/so-post-interphace';
import {InterphaceCore} from './interphace.core';
import {SOGetInterphace} from '../../core/interphace/so-get-interphace';
import {FormField, SelectionOption} from 'lionheartland';
import {postInterphaceFormFieldOptions} from './post-interphace-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {EntityCore} from '../entity/entity.core';
import {SOGetEntity} from '../../core/entity/so-get-entity';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostInterphace extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postInterphaceFormFieldOptions);

  RequestClass = SOPostInterphace

  constructor(
    public entityCore: InterphaceCore
  ) {
    super();
    if (postInterphaceFormFieldOptions.entity) {
      postInterphaceFormFieldOptions.entity.makeCore = true;
    }
    if (postInterphaceFormFieldOptions.project) {
      postInterphaceFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('interphaceType'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'entity',
        SOGetEntity,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}